import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';

interface Breadcrumb {
    label: string;
    url?: string;
}

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './app.breadcrumb.component.html'
})
export class AppBreadcrumbComponent implements OnInit {

    private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);

    readonly breadcrumbs$ = this._breadcrumbs$.asObservable();

    private test$!: Observable<any>;

    breadcrumbs: Breadcrumb[] = [];

    constructor (
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private translate: TranslateService
    ) {


    }

    ngOnInit(): void {
        //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
        //Add 'implements OnInit' to the class.
        //        this.updateBreadCrumbs();
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                this.updateBreadCrumbs();
            });

        // Inicializar breadcrumbs al cargar
        this.updateBreadCrumbs();
    }

    private updateBreadCrumbs(): void {
        let currentRoute = this.router.routerState.snapshot.root;

        // Navega hasta la ruta activa más interna
        while (currentRoute.firstChild) {
            currentRoute = currentRoute.firstChild;
        }

        // Accede a los datos resueltos desde el snapshot
        const data = currentRoute.data['breadcrumbs'];
        //console.log('Snapshot Breadcrumbs en el Componente:', data);
        this.breadcrumbs = data || [];
        this._breadcrumbs$.next(this.breadcrumbs);
    }



}
